/**
 * Sync completion event dispatched when Carrier API finishes fetching new data.
 * Listen for this to show Luxe success notification (e.g. on Your Earnings Watch).
 */
export const SYNC_COMPLETE_EVENT = 'syncComplete';

/**
 * Ledger refresh event: dispatch when commission/ledger data changes so Dashboard
 * and Smart Ledger (Your Earnings Watch) can refetch. Fired on sync complete
 * and after report/audit processing.
 */
export const LEDGER_REFRESH_EVENT = 'ledgerRefresh';

export interface SyncCompleteDetail {
  newRecords: number;
  totalCommissionAmount: number;
}

export function dispatchSyncComplete(detail: SyncCompleteDetail): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(
    new CustomEvent(SYNC_COMPLETE_EVENT, { detail })
  );
  dispatchLedgerRefresh();
}

/** Call after sync or report processing so Dashboard and Smart Ledger refresh. */
export function dispatchLedgerRefresh(): void {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent(LEDGER_REFRESH_EVENT));
}
